import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

export default function ResponsibleGamingFooter() {
    return (
        <Box component="footer" sx={{ mt: 4, py: 3, borderTop: 1, borderColor: 'divider' }}>
            <Container maxWidth="md">
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
                    You must be 21+ to use this site. This is an independent site. We are not affiliated
                    with, sponsored by, or endorsed by any casino reviewed here. All trademarks belong to
                    their respective owners. Gambling involves risk. For free, confidential support, call{' '}
                    <Link href="tel:1-800-426-2537" color="inherit" underline="hover">1-800-GAMBLER</Link>{' '}
                    (US) or visit{' '}
                    <Link href="https://www.gambleaware.org" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover">GambleAware</Link>.
                    {' '}Enjoy responsibly.
                </Typography>
            </Container>
        </Box>
    )
}
